import { supabase } from './supabaseClient'

export async function listOpenExamSessionsForStudent() {
  const { data, error } = await supabase.rpc('exam2_list_open_sessions_for_student_v2')
  if (error) throw error
  return data || []
}

export async function getOrCreateExamAttempt(sessionId) {
  if (!sessionId) throw new Error('Missing sessionId')
  const { data, error } = await supabase.rpc('exam2_get_or_create_attempt', { p_session_id: sessionId })
  if (error) throw error
  return data
}

export async function saveExamAnswer({ attemptId, questionId, answer }) {
  if (!attemptId || !questionId) throw new Error('Missing attemptId or questionId')
  const { error } = await supabase.rpc('exam2_save_answer', {
    p_attempt_id: attemptId,
    p_question_id: questionId,
    p_answer: answer ?? {},
  })
  if (error) throw error
}

export async function submitExamAttempt(attemptId) {
  if (!attemptId) throw new Error('Missing attemptId')
  const { data, error } = await supabase.rpc('exam2_submit_attempt', { p_attempt_id: attemptId })
  if (error) throw error
  return data
}

export async function getExamAttemptPayloadForStudent(attemptId) {
  if (!attemptId) throw new Error('Missing attemptId')
  const { data, error } = await supabase.rpc('exam2_get_attempt_payload_for_student', {
    p_attempt_id: attemptId,
  })
  if (error) throw error
  return data
}
